import React from 'react';
import MyLazyComponent from '@/common/lazy-load';
import PageStore from '@/stores/page';
interface PropType {
  title: string;
  images?: string[];
  list: AttributeTypes.ProductBasicProperty[];
}

export default function Item(props: PropType) {
  const { list = [], images = [], title = '' } = props;
  if (list.length === 0) return null;
  const pageStore = PageStore((state) => state);
  const { isLoaded } = pageStore;
  const AttTip = MyLazyComponent(() => import('./tip'));

  return (
    <>
      <h4>{title}</h4>
      <div className="attribute-list">
        {list.map((item, index) => (
          <div className="attribute-item" key={item.attrName}>
            <div className="left">{item.attrName}</div>
            <div className="right">
              <span
                dangerouslySetInnerHTML={{
                  __html: item.attrValue,
                }}
              ></span>
              {isLoaded && images.length > 0 && (
                <p>{index === 0 && images.map((src) => <AttTip item={src} />)}</p>
              )}
            </div>
          </div>
        ))}
      </div>
    </>
  );
}
